/**
 * @generated SignedSource<<f32a7f651efe1ad4f828384ca21a7478>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type CommentActionsWriteReactionsSummaryFragment$data = {
  readonly ari: string;
  readonly containerAri: string;
  readonly reactionsCount: number;
  readonly reactionsSummaryForEmoji: ReadonlyArray<{
    readonly count: number;
    readonly emojiId: string;
    readonly id: string;
    readonly reacted: boolean;
  } | null | undefined>;
  readonly " $fragmentType": "CommentActionsWriteReactionsSummaryFragment";
};
export type CommentActionsWriteReactionsSummaryFragment$key = {
  readonly " $data"?: CommentActionsWriteReactionsSummaryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CommentActionsWriteReactionsSummaryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "CommentActionsWriteReactionsSummaryFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "ari"
    },
    {
      "kind": "ScalarField",
      "name": "containerAri"
    },
    {
      "kind": "ScalarField",
      "name": "reactionsCount"
    },
    {
      "concreteType": "ReactionsSummaryForEmoji",
      "kind": "LinkedField",
      "name": "reactionsSummaryForEmoji",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "id"
        },
        {
          "kind": "ScalarField",
          "name": "emojiId"
        },
        {
          "kind": "ScalarField",
          "name": "count"
        },
        {
          "kind": "ScalarField",
          "name": "reacted"
        }
      ]
    }
  ],
  "type": "ReactionsSummaryResponse"
};

(node as any).hash = "ac7b970423a77e8bceb853bf1fae7a69";

export default node;
